import styled from 'styled-components'

const HeaderStyled = styled.header`
  position: sticky;
  z-index: 100000;
  width: 100%;
  padding: 0.9rem 1.5rem;
  display:flex;
  justify-content:space-between;
  align-items: center;
  font-size: 1.2em;
  background: ${({ backgroundColor }) => backgroundColor || 'transparent'};
  button {
    background: none;
    border: none;
  }
  .disabled {
    pointer-events: none;
    cursor: default;
    text-decoration: none;
    visibility: hidden;
  }
`

export default HeaderStyled
